import {InitialRequestUrl, RequestInfo} from "@repo/shared-core";
import {parseUrl} from "@repo/urls";

import {isAPIURL} from "./is-api-url.ts";

/**
 * Add a config params for all Khan Academy API calls if it does not already
 * have the parameter set. The full list of parameters can be found in
 * initial-request-url.js.
 *
 * @param url the URL of the request
 * @returns the potentially-modified URL
 */
export const addConfigParams = (url: string): string => {
    // We only process URLs that are going to an API endpoint
    if (!isAPIURL(url)) {
        return url;
    }

    // Use `parseUrl` to make the URL easy to work with
    const configURL = parseUrl(url);

    // Go through all the config params
    for (const param of Object.keys(InitialRequestUrl.configParams)) {
        // Get the value of the config param
        const value =
            InitialRequestUrl.configParams[param] ||
            // Even though it's named "lang" we need to be using the kaLocale
            // for this value to ensure consistency with the backend.
            (param === "lang" ? RequestInfo.kaLocale : "");

        // We filter out any values that aren't explicitly set and we don't
        // set a param if one already exists
        if (value && !configURL.searchParams.has(param)) {
            configURL.searchParams.set(param, value as string);
        }
    }

    return configURL.href;
};
